<template>
  <div class="overflow-auto my-5">
   
    <b-table
      outlined hover
      id="my-table"
      :items="data"
      :fields="columns"
      :per-page="perPage"
      :current-page="currentPage"
      small
    >

    <!-- Currency format total-->
    <template v-slot:cell(total)="{ item }">
      ${{ item.total }}
    </template>

    <!-- Button View Detail -->
    <template v-slot:cell(view_details)="{ item }">
        <b-btn 
          size="sm" 
          variant="info"
          @click="viewDetail(item.kp_invoice_number)">View Detail
        </b-btn>
    </template>

    </b-table>

    <p><b>Total Records:</b> {{ rows }}</p>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>

  </div>
</template>

<script>
  export default {

    props: {
        data : {
            type: Array,
            required: true
        }
    },

    data() {
      return {
        perPage: 10,
        currentPage: 1,
        columns: [
          { key: 'invoice_date', label: 'Invoice Date', sortable: true },
          { key: 'invoice_number', label: 'Invoice Number', sortable: true },
          { key: 'total', label: 'Total', sortable: true }, 
          { key: 'view_details'}       
        ],
      }
    },

    computed: {
      rows() {
        return this.data.length
      }
    },

    methods: {
      viewDetail(invoice_number) { 
        this.$router.push({
          name: "invoice-details",
          params:{
            id: invoice_number,         
          }
        });
      }
    }

  }
</script>